import location from '@/assets/location.svg'
import metro from '@/assets/metro.svg'
import map from '@/assets/map.png'
import hotel_1 from '@/assets/hotel/hotel_1.webp'
import hotel_2 from '@/assets/hotel/hotel_2.webp'
import hotel_3 from '@/assets/hotel/hotel_3.webp'
import hotel_4 from '@/assets/hotel/hotel_4.webp'
const contacts = {
    address: {
        raw: 'Санкт-Петербург, Гранд Отель Эмеральд',
        icon: location,
        map: map,
        url: 'https://yandex.ru/maps/-/CHe54P0V',
        b1: 'Санкт-Петербург',
        b2: '6-я Советская ул., 12',
        b3: 'Гранд Отель Эмеральд',
        image: [
            hotel_1,
            hotel_2,
            hotel_3,
            hotel_4,
        ]
    },
    metro: {
        icon: metro,
        title: 'Площадь Востания'
    },
    // place: {
    //     title: 'Cosmos Saint-Petersburg Pulkovskaya Hotel',
    // },
    date: {
        raw: '16 апреля 2025',
        day: '16',
        month: 'апреля',
        year: '2025',
    },
    time: {
        raw: '10:00',
    },
    title: 'Рабочие способы получения первичных пациентов для врачей и для клиник в косметологии',
    telegram: {
        title: '@Medpervichka',
        href: 'https://t.me/Medpervichka',
    },
    whatsapp: {
        title: '@Medpervichka',
        href: 'https://wa.me/+79112200235',
    },
    email: {
        title: 'info@medpervichka.ru',
        href: 'mailto:info@medpervichka.ru',
    },
    tel: {
        title: '+7 (911) 220-02-35',
        href: 'tel:+79112200235',
    }
}
export default contacts